// extracted by mini-css-extract-plugin
export var social = "social-module--social--29e0f";
export var socialItem = "social-module--socialItem--7ab12";